import axios from 'axios'

const host = window.location.hostname
const port = window.location.port
// Si el frontend corre en el mismo puerto que el backend (producción), usar /api relativo
// Si corre en otro puerto (desarrollo con React dev server), apuntar a :5000
const isDev = port && port !== '5000' && port !== '80' && port !== '443'
const baseURL = isDev ? `http://${host}:5000/api` : '/api'

const api = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' }
})

api.interceptors.request.use(config => {
  // No sobreescribir si ya tiene Authorization (portal de clientes)
  if (!config.headers.Authorization) {
    const token = localStorage.getItem('token')
    if (token) config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export const authAPI = {
  login: (data) => api.post('/auth/login', data),
  register: (data) => api.post('/auth/register', data)
}

export const clientsAPI = {
  getAll: () => api.get('/clients'),
  getExpired: () => api.get('/clients/expired'),
  getById: (id) => api.get(`/clients/${id}`),
  create: (data) => api.post('/clients', data),
  update: (id, data) => api.put(`/clients/${id}`, data),
  remove: (id) => api.delete(`/clients/${id}`),
  registerPayment: (id, data) => api.post(`/clients/${id}/payment`, data)
}

export const paymentsAPI = {
  getAll: () => api.get('/payments'),
  getMonthly: (month, year) => api.get(`/payments/monthly?month=${month}&year=${year}`),
  create: (data) => api.post('/payments', data),
  remove: (id) => api.delete(`/payments/${id}`)
}

export const classesAPI = {
  getAll: () => api.get('/classes'),
  getById: (id) => api.get(`/classes/${id}`),
  create: (data) => api.post('/classes', data),
  update: (id, data) => api.put(`/classes/${id}`, data),
  enroll: (id, clientId) => api.post(`/classes/${id}/enroll`, { clientId }),
  unenroll: (id, clientId) => api.post(`/classes/${id}/unenroll`, { clientId })
}

export const attendanceAPI = {
  getAll: (date) => api.get(`/attendance?date=${date || ''}`),
  checkIn: (data) => api.post('/attendance/checkin', data),
  getByClient: (id) => api.get(`/attendance/client/${id}`),
  getQR: (classId) => api.get(`/attendance/qr/${classId}`),
  getFixedQR: () => api.get('/attendance/qr-fixed'),
  qrCheckIn: (token, clientId) => api.post('/attendance/qr-checkin', { token, clientId }),
  autoCheckIn: (clientId) => api.post('/attendance/qr-auto-checkin', { clientId }),
  setMode: (id, modo, config) => api.post(`/portal/attendance/${id}/mode`, { modo }, config),
  remove: (id) => api.delete(`/attendance/${id}`)
}

export const dashboardAPI = {
  getStats: () => api.get('/dashboard/stats')
}

export const alertsAPI = {
  getAll: () => api.get('/alerts'),
  resolve: (id) => api.put(`/alerts/${id}/resolve`)
}

export const phrasesAPI = {
  getToday: () => api.get('/phrases/today'),
  getAll: () => api.get('/phrases'),
  create: (phrase, date) => api.post('/phrases', { phrase, date })
}

export const whatsappAPI = {
  getStatus: () => api.get('/whatsapp/status'),
  sendTest: (phone, message) => api.post('/whatsapp/test', { phone, message }),
  triggerCheck: () => api.post('/whatsapp/trigger-check'),
  restart: () => api.post('/whatsapp/restart'),
  logout: () => api.post('/whatsapp/logout'),
  connectPhone: (phoneNumber) => api.post('/whatsapp/connect-phone', { phoneNumber }),
  startQR: () => api.post('/whatsapp/start-qr'),
  getPauseStatus: () => api.get('/whatsapp/pause-status'),
  pause: (until) => api.post('/whatsapp/pause', { until }),
  resume: () => api.post('/whatsapp/resume')
}

export const portalAPI = {
  login: (name, lastName, code) => api.post('/portal/login', { name, lastName, code }),
  getProfile: (config) => api.get('/portal/profile', config),
  getPayments: (config) => api.get('/portal/payments', config),
  getAttendance: (config) => api.get('/portal/attendance', config),
  getClasses: (config) => api.get('/portal/classes', config),
  enroll: (classId, config) => api.post(`/portal/classes/${classId}/enroll`, {}, config),
  unenroll: (classId, config) => api.post(`/portal/classes/${classId}/unenroll`, {}, config)
}

export const weightRecordsAPI = {
  getAll: (config) => api.get('/weight-records', config),
  create: (data, config) => api.post('/weight-records', data, config),
  remove: (id, config) => api.delete(`/weight-records/${id}`, config)
}

export const settingsAPI = {
  getAll: () => api.get('/settings'),
  update: (key, value) => api.put(`/settings/${key}`, { value })
}

export default api
